export enum FractionLogicEnum {
  Or = 'OR',
  AndNot = 'AND_NOT'
}
